export class UserAddress {
  address;
  block;
  cityName;
  comment;
  createAt;
  deliveryData;
  deliveryMethodName;
  entrance;
  flat;
  floor;
  hasElevator;
  house;
  id;
  intercom;
  lat;
  lon;
  regionName;
  street;
  unrestrictedAddress;
  updatedAt;
  zip;
  computedAddress;
  elevator;
  cityId;
  constructor(data) {
    if (data) {
      this.address = data.address;
      this.block = data.block;
      this.cityName = data.city_name;
      this.comment = data.comment;
      this.flat = data.flat;
      this.floor = data.floor;
      this.entrance = data.entrance;
      this.lat = data.lat;
      this.lon = data.lon;
      this.zip = data.zip;
      this.hasElevator = data.has_elevator;
      this.intercom = data.intercom;
      this.regionName = data.region_name;
      this.street = data.street;
      this.unrestrictedAddress = data.unrestricted_address;
      this.createAt = data.created_at;
      this.updatedAt = data.updated_at;
      this.deliveryData = data.delivery_data;
      this.deliveryMethodName = data.delivery_method_name;
      this.id = data.id;
      this.house = data.house;
      this.computedAddress = data.computed_address;
      this.elevator = data.elevator;
      this.cityId = data.city_id;
    }
  }
  toJSON() {
    return { ...this };
  }
  static toSnakeCase(input) {
    return input.replace(/(?:^|\.?)([A-Z])/g, (x, y) => "_" + y.toLowerCase()).replace(/^_/, "");
  }
  static toBackendFormat(data) {
    const keysToExtract = Object.keys(data);
    const extractedData = {};
    keysToExtract.forEach((key) => {
      const snakeCaseKey = this.toSnakeCase(key);
      extractedData[snakeCaseKey] = data[key];
    });
    return extractedData;
  }
}
